import React, { useState, useEffect } from 'react';
import { Container, Row, Col, ListGroup } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { getSections } from '../../../../../../services/Public/Renewal/EI/eiRenewal.service';
import Information from '../../../../../Shared/Card/Information';
import { GetRenewalInformationContent } from '../../../../../Shared/InformationContent/EiInformation';
import Section from '../../../../../Shared/Sections/Section';
import issuesService from '../../../../../../services/Shared/issues.service';

function Index() {
    const [sections, setSections] = useState(null);
    const selector = useSelector(x => x);
    useEffect(() => {
        getSections().then((response) => {
            issuesService.getIssuesForSections(2, selector.currentApplicationId).then((data) => {
                setSections(selector.currentRoutes != null ? selector.currentRoutes.map((value, i) => {
                    var section = {
                        ...response.filter(x => x.id == value.sectionId)[0]
                    };
                    if (section?.id) {
                        section.link = value.route;
                        var issues = data.data.filter(x => x.sectionId == section.id);
                        if (issues.length) {
                            section.status = `${issues[0].openIssueCount} Issue${issues[0].openIssueCount > 1 ? 's' : ''}`;
                        }
                        return <Section data={section} key={i} />
                    }
                    return;
                }) : []);
            })
        })
    }, [])
    return (
        <div className="eiRenewalIndexPage">
            <Container fluid>
                <h4>Engineer Intern Renewal</h4>
                <br />
                <Row>
                    <Col><Information content={GetRenewalInformationContent("index")} /></Col>
                </Row>
                <br />
                <Row>
                    <Col>
                        <h4>Sections to Complete</h4>
                        <ListGroup>
                            {sections}
                        </ListGroup>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}
export default Index;